import React from "react";
import TapHelper from "../../services/TapHelper";

const TapInput = ({
    value,
    onChange,
    onKeyDown,
    style = {},
    placeholder = "",
    type = "text",
    name,
    disabled = false,
    error,
    className = "",
    autoComplete="off"
}) => {

    const onChangeHandler = (e) => {
        let newValue = TapHelper.sanitizeObject(e.target.value);
        // Clone event and override target.value
        const modifiedEvent = {
            ...e,
            target: { ...e.target, value: newValue, name : e.target.name },
        };
        if (onChange) onChange(modifiedEvent);
    }


    return (
        <>
            <input
                autoComplete="{autoComplete}"
                id={name}
                name={name}
                type={type}
                value={value}
                onChange={onChangeHandler}
                onKeyDown={onKeyDown}
                placeholder={placeholder}
                disabled={disabled}
                className={`${error && "border-danger"} ${className}`}
                style={style}
            />
            {error && <span className="text-sm text-danger  mt-1">{error}</span>}
        </>
    );
};

export default TapInput; 